import styled from 'styled-components';

const color = '#0D2075';

export const OutlinedButton = styled.button`
align-self: center;
border: 1px solid ${color};
color: ${color};
border-radius: 3px;
padding: .25em 1.5em;
background: none;
font-size: 12px;
font-weight: 700;
cursor: pointer;
`;
